import {Company} from '@legit.health/ui';
import {Box} from '@mui/material';
import Typography from '@mui/material/Typography';

export default function CompanyLogo({company}: {company: Company}) {
  return (
    <>
      {company.image ? (
        <Box
          data-testid="sidebarCompanyLogo"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            maxHeight: {
              xs: '75px',
              lg: '100px'
            },
            '& > img': {
              display: 'block',
              maxWidth: '100%',
              objectFit: 'contain',
              mixBlendMode: 'multiply',
              filter: 'brightness(1.1)'
            }
          }}
        >
          <img src={company.image} alt={company.name} />
        </Box>
      ) : (
        <Typography
          variant="h3"
          align="center"
          sx={{
            mb: '16px'
          }}
        >
          {company.name}
        </Typography>
      )}
    </>
  );
}
